/* LUMINANTE - Barre d'achat sticky des fiches produit.

   Principe : AUCUNE seconde logique de panier. Le bouton de la barre
   delegue son clic au bouton d'achat reellement actif de la fiche.
     · pack 1 (ou produit sans pack) -> bouton natif Horizon
     · pack 2 ou 3                   -> bouton du bloc lum-bundle
   C'est donc le thème qui ajoute au panier, avec son variant, sa quantite,
   ses evenements, sa pastille et son tiroir. On ne fait que declencher.

   Apparition : un IntersectionObserver sur une ancre posee juste apres la
   zone d'achat. Aucun listener de defilement, aucun polling. */
(() => {
  const barre = document.querySelector('[data-lum-barre]');
  const details = document.querySelector('.product-details');
  const zone = document.querySelector('.buy-buttons-block');
  if (!barre || !details || !zone) return;

  const cta = barre.querySelector('[data-lum-barre-ajouter]');
  const prixNode = barre.querySelector('[data-lum-barre-prix]');
  const ancienNode = barre.querySelector('[data-lum-barre-ancien]');
  const bundle = details.querySelector('.lum-bundle');
  const libelleLong = barre.querySelector('.lum-barre-achat__long');
  const libelleCourt = barre.querySelector('.lum-barre-achat__court');
  const motLong = libelleLong?.textContent || '';
  const motCourt = libelleCourt?.textContent || '';
  const EVENEMENT = 'shopify:cart:lines-update';

  /* Le bouton du pack n'existe que sur les bougies, et il n'est visible
     qu'à partir de 2 bougies. lum-bundle.js pose `hidden` sur l'un ou sur
     l'autre : on lit donc cet etat plutot que de le recalculer. */
  const boutonPack = () => {
    const b = bundle?.querySelector('[data-ajouter]');
    return b && !b.hidden ? b : null;
  };
  const boutonNatif = () => zone.querySelector('button[name="add"]');
  const boutonActif = () => boutonPack() || boutonNatif();

  const texte = (el) => (el ? el.textContent.trim() : '');

  /* Prix affiche = celui de l'offre reellement selectionnee, jamais une
     valeur recalculee. La carte du palier coche porte deja le montant et,
     pour les packs, le prix barre. Sans pack, on lit le prix de la fiche. */
  function maj() {
    const palier = bundle
      ?.querySelector('.lum-bundle__palier input:checked')
      ?.closest('.lum-bundle__palier');

    const prix = texte(palier?.querySelector('.lum-bundle__montant')) || texte(details.querySelector('.price'));
    const ancien =
      texte(palier?.querySelector('.lum-bundle__barre')) ||
      (palier ? '' : texte(details.querySelector('.compare-at-price')));

    if (prix) prixNode.textContent = prix;
    ancienNode.textContent = ancien;
    ancienNode.toggleAttribute('hidden', !ancien);

    const b = boutonActif();
    if (!occupe) cta.disabled = !b || b.disabled;
  }

  /* Un seul recalcul par frame : un changement de variante re-rend la
     section entiere, un changement de palier declenche un `change`. */
  let prevu = false;
  const planifier = () => {
    if (prevu) return;
    prevu = true;
    requestAnimationFrame(() => {
      prevu = false;
      maj();
    });
  };
  details.addEventListener('change', planifier);
  new MutationObserver(planifier).observe(details, {
    childList: true,
    subtree: true,
    characterData: true,
  });

  /* Libelle court sur les ecrans etroits : mesure reelle, pas de seuil
     devine. On bascule si le libelle long deborde de son bouton. */
  const ajusterLibelle = () => {
    if (!libelleLong || !libelleCourt) return;
    barre.classList.remove('lum-barre-achat--court');
    if (barre.hidden) return;
    if (libelleLong.scrollWidth > libelleLong.clientWidth + 1) {
      barre.classList.add('lum-barre-achat--court');
    }
  };
  new ResizeObserver(ajusterLibelle).observe(barre);

  /* Ancre de 1 px posee juste apres la zone d'achat, dans la meme colonne
     de blocs. ⚠️ NE PAS viser `zone.closest('.group-block')` : ce bloc
     enveloppe TOUTE la colonne d'achat, et `.product-details` est un flex
     en LIGNE, donc l'ancre se retrouvait a cote de la colonne, en haut de
     page, et la barre ne se declenchait jamais. `.buy-buttons-block` passe
     en `hidden` quand un pack de 2 ou 3 est choisi, mais l'ancre est un
     frere autonome : elle garde sa boite, seule sa position remonte de la
     hauteur du bouton. */
  const ancre = document.createElement('div');
  ancre.className = 'lum-barre-ancre';
  ancre.setAttribute('aria-hidden', 'true');
  zone.after(ancre);

  /* 🔴 La racine de l'observateur DOIT etre le conteneur qui defile
     reellement, pas la fenetre. Au-dessus de 990 px le theme fait defiler
     `.page-wrapper` (html est en overflow:hidden) : cet ancetre ROGNE
     l'intersection, l'ancre etait donc « hors vue » aussi bien avant
     qu'apres la zone d'achat, l'etat ne basculait jamais et la barre
     n'apparaissait jamais. Le conteneur qui defile changeant a 990 px, on
     rebranche l'observateur quand la fenetre change de taille. */
  const scrollerDe = (el) => {
    let p = el.parentElement;
    while (p && p !== document.body && p !== document.documentElement) {
      const ov = getComputedStyle(p).overflowY;
      if ((ov === 'auto' || ov === 'scroll') && p.scrollHeight > p.clientHeight + 1) return p;
      p = p.parentElement;
    }
    return null;
  };

  /* ⚠️ On lit la GEOMETRIE : « hors vue » est vrai au-dessus comme en
     dessous de l'ecran, et la barre s'affichait donc des le haut de la
     fiche. La racine etiree tres loin vers le bas garantit que la bascule
     se produise a un seul endroit ; ce test dit de quel cote on est. */
  const evaluer = (rect, hautRacine) => {
    const passee = rect.bottom <= hautRacine;
    if (passee) maj();
    barre.toggleAttribute('hidden', !passee);
    ajusterLibelle();
  };

  let observateur = null;
  const brancher = () => {
    observateur?.disconnect();
    observateur = new IntersectionObserver(
      ([e]) => evaluer(e.boundingClientRect, e.rootBounds ? e.rootBounds.top : 0),
      { root: scrollerDe(ancre), threshold: 0, rootMargin: '0px 0px 100000px 0px' }
    );
    observateur.observe(ancre);
  };
  brancher();

  let minuteurTaille;
  addEventListener(
    'resize',
    () => {
      clearTimeout(minuteurTaille);
      minuteurTaille = setTimeout(brancher, 200);
    },
    { passive: true }
  );

  /* Ajout : un seul clic pris en compte tant que le panier n'a pas
     repondu. Le thème porte l'ajout, on ne fait que verrouiller la barre
     et rendre la confirmation visible ici, ou le client regarde. */
  let occupe = false;
  cta.addEventListener('click', () => {
    if (occupe) return;
    const b = boutonActif();
    if (!b || b.disabled) return;

    /* Coffrets : les menus de parfums sont des champs `required` du
       formulaire produit. Si l'un est vide, le clic ne part pas au panier,
       la validation native affiche son message et remet le focus sur le
       champ. On laisse ce clic passer mais SANS verrouiller la barre,
       sinon elle resterait grisee pour rien jusqu'au filet de securite. */
    const formulaire = b.form || b.closest('form');
    if (formulaire && typeof formulaire.checkValidity === 'function' && !formulaire.checkValidity()) {
      b.click();
      return;
    }

    occupe = true;
    cta.disabled = true;
    cta.setAttribute('aria-busy', 'true');

    let fini = false;
    const relacher = (reussi) => {
      if (fini) return;
      fini = true;
      clearTimeout(minuteur);
      document.removeEventListener(EVENEMENT, surPanier);
      occupe = false;
      cta.removeAttribute('aria-busy');
      maj();
      if (!reussi) return;
      barre.classList.add('lum-barre-achat--ok');
      if (libelleLong) libelleLong.textContent = cta.dataset.lumAjoute || 'Ajouté';
      if (libelleCourt) libelleCourt.textContent = cta.dataset.lumAjoute || 'Ajouté';
      setTimeout(() => {
        barre.classList.remove('lum-barre-achat--ok');
        if (libelleLong) libelleLong.textContent = motLong;
        if (libelleCourt) libelleCourt.textContent = motCourt;
        ajusterLibelle();
      }, 1800);
    };
    /* 🔴 Horizon emet `shopify:cart:lines-update` DE MANIERE OPTIMISTE,
       synchroniquement au depart de la requete, pas a son arrivee. Se
       relacher sur l'evenement seul rouvrait donc le bouton dans la meme
       milliseconde : trois clics rapides ajoutaient trois articles
       (mesure). On attend la promesse portee par l'evenement, qui est
       celle du vrai aller-retour panier. */
    const surPanier = (e) => {
      /* ⚠️ La promesse est portee par l'EVENEMENT lui-meme (`e.promise`),
         pas par `e.detail`, qui est vide : verifie en ecoutant l'evenement
         reel. Chercher dans `detail` la manquait donc a tous les coups. */
      const promesse = e?.promise || e?.detail?.promise;
      if (promesse && typeof promesse.then === 'function') {
        document.removeEventListener(EVENEMENT, surPanier);
        promesse.then(
          () => relacher(true),
          () => relacher(false)
        );
        return;
      }
      relacher(true);
    };
    document.addEventListener(EVENEMENT, surPanier);
    const minuteur = setTimeout(() => relacher(false), 4000);

    b.click();

    /* Un pack incomplet fait afficher son message par le bloc, tout en
       haut de la page : on y amene le client plutot que de le laisser
       devant un bouton qui n'a rien fait. */
    setTimeout(() => {
      const erreur = bundle?.querySelector('[data-erreur]');
      if (erreur && !erreur.hidden && erreur.textContent.trim()) {
        relacher(false);
        bundle.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    }, 150);
  });

  maj();
  ajusterLibelle();
})();
